const withResolvers = () => {
  const res = [];
  res[0] = new Promise((resolve, reject) => {
    res[1] = resolve;
    res[2] = reject;
  });
  return res;
};
const isPromise = (value) => Promise.resolve(value) === value;

export { isPromise as i, withResolvers as w };
/*                                       */
